import React from 'react'
import { Button, ButtonGroup, Form } from 'react-bootstrap'

export default function AxisStylePanel({
  visualOptions,
  setVisualOptions,
  supportsAxisTitles = false,
  supportsAxisGuides = false,
}) {
  const axisTitlesEnabled = visualOptions?.showAxisTitles !== false
  const verticalAxisLinesEnabled = Boolean(visualOptions?.showVerticalAxisLines)
  const horizontalAxisLinesEnabled = Boolean(visualOptions?.showHorizontalAxisLines)

  const updateAxisTitles = (enabled) => {
    setVisualOptions({
      ...visualOptions,
      showAxisTitles: enabled,
    })
  }

  const updateAxisGuideLines = (key, enabled) => {
    setVisualOptions({
      ...visualOptions,
      [key]: enabled,
    })
  }

  if (!supportsAxisTitles && !supportsAxisGuides) {
    return null
  }

  return (
    <>
      {supportsAxisTitles ? (
        <div className="appearance-section">
          <label className="appearance-swatch-label" htmlFor="chart-axis-titles">
            Axis titles
          </label>
          <div className="layout-style-slider-row">
            <Form.Check
              id="chart-axis-titles"
              type="switch"
              checked={axisTitlesEnabled}
              onChange={(event) => updateAxisTitles(event.target.checked)}
              label={axisTitlesEnabled ? 'On' : 'Off'}
            />
          </div>
          <div className="small text-muted">
            Shows or hides the axis titles while leaving tick labels visible.
          </div>
        </div>
      ) : null}

      {supportsAxisGuides ? (
        <div className="appearance-section">
          <label className="appearance-swatch-label">Axis lines</label>
          <div className="small text-muted mb-2">
            D3-style guide lines drawn from axis ticks into the chart area.
          </div>
          {supportsAxisGuides ? (
            <ButtonGroup className="d-flex flex-wrap mb-3">
              <Button
                type="button"
                variant={verticalAxisLinesEnabled ? 'success' : 'outline-secondary'}
                className="flex-fill"
                onClick={() =>
                  updateAxisGuideLines(
                    'showVerticalAxisLines',
                    !verticalAxisLinesEnabled
                  )
                }
              >
                Vertical lines
              </Button>
              <Button
                type="button"
                variant={horizontalAxisLinesEnabled ? 'success' : 'outline-secondary'}
                className="flex-fill"
                onClick={() =>
                  updateAxisGuideLines(
                    'showHorizontalAxisLines',
                    !horizontalAxisLinesEnabled
                  )
                }
              >
                Horizontal lines
              </Button>
            </ButtonGroup>
          ) : null}
        </div>
      ) : null}
    </>
  )
}
